class DetectTab {
    constructor() {
        this.isKeyboard = false;
        this.bindEvents();
    }

    bindEvents() {
        document.addEventListener('keydown', event => {
                if (event.key === 'Tab') {
                    this.setKeyboard();
                }
            }
        );
        document.addEventListener('click', () => this.setMouse());
    }

    setKeyboard() {
        if (!this.isKeyboard) {
            document.querySelector('body').classList.add('keyboard-input');
            this.isKeyboard = true;
        }
    }

    setMouse() {
        if (this.isKeyboard) {
            document.querySelector('body').classList.remove('keyboard-input');
            this.isKeyboard = false;
        }
    }

}

function AddSkipLink() {
    let link;
    const wizard = document.querySelector('[data-wizard]');
    if (wizard){
        link = `<a class="skip-link button button--3 focus-visible" href="#wizardContent">Skip to main</a>`
    } else {
        link = `<a class="skip-link button button--3 focus-visible" href="#main">Skip to main</a>`
    }
    document.querySelector('body').insertAdjacentHTML(`afterbegin`, link);
}

document.addEventListener('DOMContentLoaded', () => {
    new DetectTab;
    if(document.querySelector("header")) AddSkipLink();
});